import React, { useEffect, useRef } from 'react';
import { Check } from 'lucide-react';
import { consumeRemindFlagIfSet } from '../../../lib/basketPlacementCelebration';
import './BasketPlacementCelebrationOverlay.css';

const BasketPlacementCelebrationOverlay = ({
  movedTopicName,
  userId,
  onContinue,
  onRemindAgain,
  embedded = false,
}) => {
  const continueRef = useRef(null);

  useEffect(() => {
    consumeRemindFlagIfSet(userId);
    continueRef.current?.focus();
  }, [userId]);

  const positionType = embedded ? 'absolute' : 'fixed';

  return (
    <div
      className={`placement-celebration-backdrop ${positionType} inset-0 z-[60] flex items-center justify-center bg-emerald-600 bg-opacity-90 p-4`}
      role="dialog"
      aria-labelledby="placement-celebration-headline"
      aria-modal="true"
      onClick={onContinue}
    >
      <div
        className="placement-celebration-card bg-white rounded-xl border-2 border-neutral-900 p-6 sm:p-8 shadow-lg"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="placement-celebration-icon-wrap" aria-hidden="true">
          <Check size={24} strokeWidth={2.5} className="placement-celebration-icon" />
        </div>

        <p id="placement-celebration-headline" className="placement-celebration-headline text-center">
          Great job! Next time you study a new topic and browse for a basket, watch for{' '}
          <span className="placement-celebration-topic">{movedTopicName}</span>
          {' '}
          - it&apos;ll be there, hard detail and all. That&apos;s automatic review.
        </p>

        <p className="placement-celebration-supporting text-center">
          That&apos;s the opposite of how most study. Moving to new subjects weakens recall of
          previous topics. Here, moving forward actually reinforces what&apos;s behind you.
        </p>

        <hr className="placement-celebration-divider" />

        <div className="placement-celebration-actions">
          <button
            ref={continueRef}
            type="button"
            onClick={onContinue}
            className="placement-celebration-continue"
          >
            Continue
          </button>
          <button
            type="button"
            onClick={onRemindAgain}
            className="placement-celebration-remind"
          >
            Remind me again
          </button>
        </div>
      </div>
    </div>
  );
};

export default BasketPlacementCelebrationOverlay;
